import { useState, useEffect, useRef } from "react";

function useClickOutside(initialState = false) {
  const [isOpen, setIsOpen] = useState(initialState);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return [isOpen, toggle, containerRef, setIsOpen];
}

export default useClickOutside;
